import React from "react";
import { PageLayout, Background } from "@bluefin/components";
import { Grid, Header, Card } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class EventsPage extends React.PureComponent {
  render() {
    return (
      <WebsiteLayout>
        <PageLayout
          hero={
            <Background
              columns={1}
              stackable={true}
              className={"events-hero"}
            />
          }
          subfooter={false}
          className={"events-page"}
        >
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={14} textAlign={"center"}>
              <Header as={"h1"}>Events</Header>
              <Grid stackable={true} verticalAlign={"middle"} columns={"equal"}>
                <Grid.Column>
                  <Card>
                    <Card.Content>
                      <Card.Header>Trivia</Card.Header>
                    </Card.Content>
                    <Card.Content extra={true}>
                      <span>Tuesdays</span>
                    </Card.Content>
                  </Card>
                </Grid.Column>
                <Grid.Column>
                  <Card>
                    <Card.Content>
                      <Card.Header>Karaoke</Card.Header>
                    </Card.Content>
                    <Card.Content extra={true}>
                      <span>Wednesday</span>
                    </Card.Content>
                  </Card>
                </Grid.Column>
                <Grid.Column>
                  <Card>
                    <Card.Content>
                      <Card.Header>Video Games</Card.Header>
                    </Card.Content>
                    <Card.Content extra={true}>
                      <span>Thursday</span>
                    </Card.Content>
                  </Card>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}
